<div class="relative w-full">
  <mat-icon
  class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-grayNovo cursor-pointer">language</mat-icon>
  <select title="language" (change)="switchLanguage($event)"
    class="appearance-none w-full pl-10 pr-8 py-1 rounded-buttonAction text-grayNovo border border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200 cursor-pointer">
    @for (lang of languages; track lang) {
      <option [value]="lang.code" [selected]="translateService.currentLang === lang.code">
        {{ lang.name }}
      </option>
    }
  </select>
</div>